export function getPlainDeepKeysValues(obj) {
    const pairs = [];
  
    const walk = (o, parent = null) => {
        for (const [k, v] of Object.entries(o)) {
            let current = parent ? parent + '.' + k : k;

            if (typeof v !== 'object'){
                pairs.push({[current]: v});   
            }

            if (
                Object.prototype.toString.call(v) === '[object Object]' ||
                Array.isArray(v)
            ) {
                walk(v, current);
            }
        }
    }
  
    walk(obj);
  
    return pairs;
}

/**
 * @description Convert object to array of (field, value) pairs to show modified
 * @param {{ stateField: string, value: any, arrayIndex?: number }} params 
 */
export function calculateDeepPaths(params) {
    const { stateField, value, arrayIndex } = params;
    const modifications = [];
    let currentIndex = arrayIndex;

    if (Array.isArray(params.value)) {
        value.forEach((item) => {
            const plains = getPlainDeepKeysValues(item);
            plains.forEach((__item) => {
                const [plainKey, plainValue] = Object.entries(__item)[0];
                let key = `${stateField}.`;
                if (arrayIndex === 0 || arrayIndex > 0) key += `${currentIndex}.`;
                modifications.push({ [getBracketPath(`${key}${plainKey}`)]: plainValue });
            });
            currentIndex++;
        });
    } else if (Object.prototype.toString.call(value) === '[object Object]') {
        const plains = getPlainDeepKeysValues(value);
        plains.forEach((item) => {
            const [plainKey, plainValue] = Object.entries(item)[0];
            let key = `${stateField}.`;
            if (arrayIndex === 0 || arrayIndex > 0) key += `${currentIndex}.`;
            modifications.push({ [getBracketPath(`${key}${plainKey}`)]: plainValue });
        });
    } else {
        modifications.push({ [stateField]: value });
    }

    return modifications;
}

function getBracketPath(path) {
    const items = path.split('.');
    let str = '';

    items.forEach((item, index) => {
        if (index === 0) {
            str += item;
        } else if (index === items.length - 1) {
            str += `.${item}`;
        } else {
            str += `[${item}]`;
        }
    });

    return str;
}



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Sidebar/Size/utils.js